<div class="mx-5 mt-5">
  <h5>{{ "Are you uploading an existing resume?" | translate }}</h5>

  <p>
    {{ "Just review, edit, and update it with new information" | translate }}
  </p>
</div>

<div class="row m-4" *ngIf="IsUploadCv === false">
  <div class="col-12 col-sm-6 mt-3 mt-sm-auto order-2 order-sm-1">
    <div
      class="card-container"
      (click)="(selectedResumeType = 'upload')"
      [ngClass]="{ selected: selectedResumeType === 'upload' }"
    >
      <img
        class="mx-auto mb-3"
        src="../../../../../../assets/img/upload resume.png"
      />
      <h5>{{ "Upload From my Resume" | translate }}</h5>
      <p>
        {{
          "We’ll give you expert guidance to fill out your info and enhance your resume, from start to finish"
            | translate
        }}
      </p>
      <!-- <p class="paner">
        {{ "Coming Soon" | translate }}
      </p> -->
      <input *ngIf="selectedResumeType === 'upload'" type="radio" checked />
    </div>
  </div>
  <div class="col-12 col-sm-6 order-1 order-sm-2">
    <div
      class="card-container"
      (click)="selectedResumeType = 'scratch'"
      [ngClass]="{ selected: selectedResumeType === 'scratch' }"
    >
      <img
        class="mx-auto mb-3"
        src="../../../../../../assets/img/writ-resume.png"
      />
      <h5>{{ "Start from scratch" | translate }}</h5>
      <p>
        {{
          "We’ll guide you through the whole process so your skills can shine"
            | translate
        }}
      </p>

      <input *ngIf="selectedResumeType === 'scratch'" type="radio" checked />
    </div>
  </div>
</div>
<div
  class="d-flex justify-content-center mb-4"
  *ngIf="loading"
>
</div>

<div class="d-flex justify-content-center align-items-center">
  <a href="https://wa.me/+201555842727" target="_blank">
    <button class="contact-btn py-1 mb-4">
      <img src="../../../assets/img/whatsapp-logo.png" />
      {{ "Contact us for custom cv" | translate }}
    </button>
  </a>
</div>
<div
  class="upload-cv mx-5"
  *ngIf="IsUploadCv === true"
  (dragover)="onDragOver($event)"
  (drop)="onCVDrop($event)"
>
  <img src="../../../../../../assets/icon/uploud-cv.png" />
  <h5>{{ "Drag and drop a file here" | translate }}</h5>
  <p>{{ "Files we can read: DOC, DOCX, PDF" | translate }}</p>
  <input
    type="file"
    id="uploadCv"
    (change)="onCVSelected($event)"
    accept=".pdf,.doc,.docx"
    #uploadCv
    hidden
  />
  <button class="gradient-button" (click)="uploadCv.click()">
    {{ "Browse" | translate }}
  </button>
</div>

<div class="next-container px-4">
  <button class="border-button m-3" (click)="onPrevious()">
    {{ "Back" | translate }}
  </button>
  <button class="gradient-button m-3" (click)="selectedResumeType && onNext()">
    {{ "Next" | translate }}
  </button>
</div>
